import { Github } from 'lucide-react';
import { Separator } from '@/components/base/separator';

const REPO_URL = 'https://github.com/getpara/solana-import';

export function Footer() {
  return (
    <footer className="para:mt-8 para:flex para:flex-col para:gap-4 para:text-center para:text-xs para:text-muted-foreground">
      <Separator />
      <p className="para:px-4 para:leading-relaxed">
        This tool is provided as-is, with no warranty. The private key you paste never leaves this browser tab — but
        anyone who obtains it can drain your wallet. Treat it as compromised after use.
      </p>
      <div className="para:flex para:flex-wrap para:items-center para:justify-center para:gap-x-4 para:gap-y-2">
        <a
          href={REPO_URL}
          target="_blank"
          rel="noreferrer"
          className="para:inline-flex para:items-center para:gap-1.5 para:rounded-full para:border para:border-border para:bg-card para:px-3 para:py-1 para:font-medium para:text-foreground para:transition-colors para:hover:bg-muted"
        >
          <Github className="para:size-3.5" />
          View on GitHub
        </a>
        <span>
          Released under the{' '}
          <a
            href={`${REPO_URL}/blob/main/LICENSE`}
            target="_blank"
            rel="noreferrer"
            className="para:underline para:underline-offset-2 para:hover:text-foreground"
          >
            MIT License
          </a>
          {' '}· © {new Date().getFullYear()} Para
        </span>
      </div>
    </footer>
  );
}
